module.exports = __webpack_public_path__ + "media/images/public-a2394a106ed8871989e9451f851aad0e.svg";